export default __webpack_public_path__ + "static/media/spring-colours.png.webp";